var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "data-user" } }, [
      _c("div", { staticClass: "row mb-5" }, [
        _vm.leader && _vm.leader.nombre
          ? _c("div", { staticClass: "col-12 mt-3" }, [
              _c("b", [_vm._v("Líder Actual:")]),
              _vm._v(" " + _vm._s(_vm.leader.nombre) + " ")
            ])
          : _vm._e(),
        !_vm.leader.nombre
          ? _c("div", { staticClass: "col-12 mt-3" }, [
              _c("b", [_vm._v("Este grupo no tiene líder")])
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-12 mt-3" },
          [
            _c("list-group-users", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              ref: "resendName",
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                label: "Usuarios",
                name: "user",
                "parent-value": _vm.group.id,
                danger: _vm.errors.has("data-user.user"),
                "danger-text": _vm.errors.first("data-user.user")
              },
              model: {
                value: _vm.process.user,
                callback: function($$v) {
                  _vm.$set(_vm.process, "user", $$v)
                },
                expression: "process.user"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "chip-custom" }, [
        _vm._v(
          " Al cambiar de líder, se reemplazará al actual y todos los procesos que estén pendientes serán traspasados a éste nuevo líder. "
        )
      ]),
      _vm.error.message !== ""
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
              staticStyle: { height: "32px" }
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.error.message) + " ")
              ])
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end mt-3" },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-primary" },
              on: { click: _vm.saveChanges }
            },
            [_vm._v(" Guardar ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }